module.exports = __webpack_public_path__ + "media/images/icon__point--text-25a63e8c6600109602344f9c04ee3c88.png";